
import { Component, Vue } from "vue-property-decorator";
import appConfig from "@/config/default/application";

@Component
export default class Maintainance extends Vue {
    get maintainanceTimeDisplay() {
        const date = appConfig?.maintainance;
        if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
            return this.$_("w_MaintenanceTBD");
        }

        const local = new Date(date.getTime());
        const pad = (value: number) => String(value).padStart(2, "0");
        const y = local.getFullYear();
        const m = pad(local.getMonth() + 1);
        const d = pad(local.getDate());
        const hh = pad(local.getHours());
        const mm = pad(local.getMinutes());
        return `${y}-${m}-${d} ${hh}:${mm} (GMT+8)`;
    }

    get supportEmailHref() {
        const email = appConfig?.supportEmail ?? "";
        const subject = encodeURIComponent(this.$_("w_MaintenanceEmailSubject"));
        return email
            ? `mailto:${email}?subject=${subject}`
            : "mailto:";
    }

    reloadPage() {
        window.location.reload();
    }
}
